import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d020915e")

_pushScopeId("data-v-d020915e")
const _hoisted_1 = /*#__PURE__*/_createVNode("span", { class: "state__circle" }, null, -1)
const _hoisted_2 = { class: "SRadio__label" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("label", {
    class: ["SRadio", { primary: _ctx.theme === 'primary', red: _ctx.theme === 'red', green: _ctx.theme === 'green' }]
  }, [
    _createVNode("input", {
      class: "SRadio__input",
      type: "radio",
      checked: _ctx.checked,
      value: JSON.stringify(_ctx.value),
      name: _ctx.name,
      hidden: "",
      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.emitChange && _ctx.emitChange(...args))),
      disabled: _ctx.disabled
    }, null, 40, ["checked", "value", "name", "disabled"]),
    _createVNode("div", {
      class: ['SRadio__state', { SRadio__state__horizontal: _ctx.isHorizontal }]
    }, [
      _hoisted_1
    ], 2),
    _createVNode("span", _hoisted_2, _toDisplayString(_ctx.label), 1)
  ], 2))
})